(function($) {
  var selectors = {
    containers: {
      quickATCForm: '.quick-atc-form'
    },
    buttons: {
      qtyAdjust: '.adjust',
      checkout: '.cart__checkout'
    }
  };
  
  var messages = {
    minNotMet: `<p class="minimum-not-met">A minimum of {minPerCategory} items is required for this product. You may mix-and-match product styles to meet the minimum.</p>`,
    checkoutDisabledMinNotMet: '<p class="checkout-minimum-not-met">Minimum items not met. To checkout update your cart to meet the minimum.</p>'
  };
  
  function formSubmitAjax(p_options) {
    var $form = p_options.$form;
    
    $.ajax({
      url : $form.attr('action'),
      type: $form.attr('method'),
      data : $form.serialize(),
      dataType: 'json'
    }).done(function(response) {
      if (typeof p_options.callback === 'function') {
        p_options.callback(response);
      }
    });      
  }
  
  function updateCartButton(cartData) {
    var $cartButton = $('[data-CartButton]');
    var $cartCount = $('#CartCount');
    var $cartCost = $('#CartCost');

    var itemCount = cartData.item_count;
    var totalPrice = theme.Currency.formatMoney(
      cartData.total_price,
      StyleHatch.currencyFormat
    );

    $cartCount.text(itemCount);
    $cartCost.removeClass('money');
    $cartCost.html('<span class="money">' + totalPrice + '</span>');

    // If Currency convertor has been added
    if (StyleHatch.currencyConverter) {
      Currency.convertAll(
        StyleHatch.shopCurrency,
        jQuery('[name=currencies]').val()
      );
    }
  }  
  
  function checkMinimumPerCategory(cart) {
    var itemsPerCategory = {};
    cart.items.forEach(function(item) {
      var itemHasMinLimit = item.properties !== null && item.properties['_qty-min'] !== undefined;
      if (itemHasMinLimit) {
        var category = item.properties['_qty-min'].split('_')[0];
        if (itemsPerCategory.hasOwnProperty(category)) {
          itemsPerCategory[category] += item.quantity;
        }
        else {
          itemsPerCategory[category] = item.quantity;
        }
      }
    });
    
    for(var category in itemsPerCategory) {
      var minPerCategory = $.grep(_Qty_per_category, function(c, i) {
        return c.handle == category;
      })[0].qty_min;
      
      if (itemsPerCategory[category] < minPerCategory) {
        $('.cart-item[data-qty-min*="' + category + '"]').find('.title').after(messages.minNotMet.replace('{minPerCategory}', minPerCategory));
        
        // disable checkout
        $(selectors.buttons.checkout).prop('disabled', true);
        $(selectors.buttons.checkout).after(messages.checkoutDisabledMinNotMet);
      }
    }
  }
  
  function getCart() {
    return new Promise(function(resolve, reject) {
      $.getJSON('/cart.js', function(data) {
        resolve(data);
      });
    });
  }
  
  $(function() {
    $(document).on('click', selectors.buttons.qtyAdjust, function(e) {
      e.preventDefault();
      
      var $qty = $(this).closest('.quantity-select').find('input.quantity');
      var $target = $(e.target);
            
      var step = $qty.data('step');
      var qty = parseInt($qty.val());

      // offset by 1 to counter default step of 1
      var requiresOffset = 
          $('body').data('template') == 'product' || 
          $('body').data('template') == 'cart';
      
      var offset = requiresOffset ? 1 : 0;
      if ($target.hasClass('adjust-plus')) { 
        qty = qty + step - offset;
      }
      else {
        qty = qty - step + offset;
        if (qty < step) {
          qty = step;
        }
      }
      
      $qty.val(qty).trigger('change');
    });
    
    // Quick ATC
    $(selectors.containers.quickATCForm).on('submit', function(e) {
      e.preventDefault();
      var $form = $(this);
      
      formSubmitAjax({
        $form: $form,
        callback: function(response) {
          //console.log(response);
          $.getJSON('/cart.js', function(cartData) {
            updateCartButton(cartData);
          });
          
          $form.append('<p class="form-success">Added to Cart!</p>')
          setTimeout(function() {
            $form.find('.form-success').remove();
          }, 1000);
        }
      });
    });
    
    // Check minimum per category
    var minPerCategoryRequired = typeof _Qty_per_category !== 'undefined' && enable_qty_per_category;
    var isCartPage = location.pathname.indexOf('/cart') !== -1;
    if (isCartPage && minPerCategoryRequired) {
      getCart()
      .then(checkMinimumPerCategory);
    }
  });
})(jQuery);